import {
  PLANS_START,
  PLANS_VE_START,
  PLANS_SUCCESS,
  PLANS_FAIL,
  PLANS_FINISH,
  PLAN_DEFAULT_SELECTED,
  PLAN_SELECTED,
  TYPE_OF_FINANCING,
  NAME_PLAN_SELECTED,
  COVERAGE_PLAN,
  SPECIAL_COVERAGE,
  PLAN_SAVING_SELECTED,
  SET_NAME_FREQUENCY,
  ADD_THIRD_SUCCESS,
  ADD_THIRD_INIT,
  SAVE_PLAN_ID,
  SET_CURRENCY_PLAN,
  SET_MAX_AMOUNT_QUOTE,
  SET_FINANCIAL_ENTITIES,
  SET_SUM_ASSURED,
  SET_PREFETCHED_SUM_ASSURED,
} from "../types/plans";

const initialState = {
  loading: false,
  plansSuccess: false,
  data: null,
  error_api_planes: {},
  planDefaultSelected: {},
  planSelected: {},
  planSavingSelected: {},
  specialCoverage: {},
  typeOfFinancing: {},
  namePlanSelected: "",
  coveragePlan: {},
  nameFrequency: "",
  currencyPlan: "SOL",
  maxAmountQuote: null,
  addThirdSuccess: false,
  financialEntities: [],
  prefetchedSumAssured: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PLANS_START:
      return {
        ...state,
        data: null,
        loading: true,
        plansSuccess: false,
      };
    case PLANS_VE_START:
      return initialState;
    case PLANS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        plansSuccess: true,
      };
    case PLANS_FAIL:
      return {
        ...state,
        loading: false,
        data: null,
        error_api_planes: action.error,
      };
    case PLANS_FINISH:
      return {
        ...state,
      };
    case PLAN_DEFAULT_SELECTED:
      return {
        ...state,
        planDefaultSelected: action.data,
      };
    case PLAN_SELECTED:
      return {
        ...state,
        planSelected: action.data,
      };
    case TYPE_OF_FINANCING:
      return {
        ...state,
        typeOfFinancing: action.data,
      };
    case NAME_PLAN_SELECTED:
      return {
        ...state,
        namePlanSelected: action.data,
      };
    case SET_NAME_FREQUENCY:
      return {
        ...state,
        nameFrequency: action.data,
      };
    case COVERAGE_PLAN:
      return {
        ...state,
        coveragePlan: action.data,
      };
    case SPECIAL_COVERAGE:
      return {
        ...state,
        specialCoverage: action.data,
      };
    case PLAN_SAVING_SELECTED:
      return {
        ...state,
        planSavingSelected: action.data,
      };
    case ADD_THIRD_INIT:
      return {
        ...state,
        addThirdSuccess: false,
      };
    case ADD_THIRD_SUCCESS:
      return {
        ...state,
        addThirdSuccess: true,
      };
    case SAVE_PLAN_ID:
      return {
        ...state,
        planSelected: {
          ...state.planSelected,
          planId: action.data,
        }
      }
    case SET_CURRENCY_PLAN:
      return {
        ...state,
        currencyPlan: action.data,
      };
    case SET_MAX_AMOUNT_QUOTE:
      return {
        ...state,
        maxAmountQuote: action.data,
      };
    case SET_FINANCIAL_ENTITIES:
      return {
        ...state,
        financialEntities: action.data,
      };
    case SET_SUM_ASSURED:
      return {
        ...state,
        planSelected: {
          ...state.planSelected,
          sumAssured: action.data,
        },
      };
    case SET_PREFETCHED_SUM_ASSURED:
      return {
        ...state,
        prefetchedSumAssured: action.data,
      };
    default:
      return state;
  }
};
